// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1Xz1q","insightsList":"newBusinessInsightsMenu_insightsList__BlVg8","active":"newBusinessInsightsMenu_active__3Ewjp"};